define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MScoreOverrideLabelsDomain = void 0;
    class MScoreOverrideLabelsDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: MScoreOverrideLabelsDomain.R, value: "R" },
                    { key: MScoreOverrideLabelsDomain.S, value: "S" },
                    { key: MScoreOverrideLabelsDomain.Q, value: "Q" },
                    { key: MScoreOverrideLabelsDomain.Qs, value: "QS" },
                    { key: MScoreOverrideLabelsDomain.Sr, value: "SR" },
                    { key: MScoreOverrideLabelsDomain.Qr, value: "QR" },
                    { key: MScoreOverrideLabelsDomain.Qsr, value: "QSR" },
                    { key: MScoreOverrideLabelsDomain.A, value: "A" },
                    { key: MScoreOverrideLabelsDomain.As, value: "AS" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[MScoreOverrideLabelsDomain.R] = 0;
                this.KeyIndex[MScoreOverrideLabelsDomain.S] = 1;
                this.KeyIndex[MScoreOverrideLabelsDomain.Q] = 2;
                this.KeyIndex[MScoreOverrideLabelsDomain.Qs] = 3;
                this.KeyIndex[MScoreOverrideLabelsDomain.Sr] = 4;
                this.KeyIndex[MScoreOverrideLabelsDomain.Qr] = 5;
                this.KeyIndex[MScoreOverrideLabelsDomain.Qsr] = 6;
                this.KeyIndex[MScoreOverrideLabelsDomain.A] = 7;
                this.KeyIndex[MScoreOverrideLabelsDomain.As] = 8;
                this.ValueIndex = {};
                this.ValueIndex["R"] = 0;
                this.ValueIndex["S"] = 1;
                this.ValueIndex["Q"] = 2;
                this.ValueIndex["QS"] = 3;
                this.ValueIndex["SR"] = 4;
                this.ValueIndex["QR"] = 5;
                this.ValueIndex["QSR"] = 6;
                this.ValueIndex["A"] = 7;
                this.ValueIndex["AS"] = 8;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.MScoreOverrideLabelsDomain = MScoreOverrideLabelsDomain;
    Object.defineProperty(MScoreOverrideLabelsDomain, "R", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "R"
    });
    Object.defineProperty(MScoreOverrideLabelsDomain, "S", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "S"
    });
    Object.defineProperty(MScoreOverrideLabelsDomain, "Q", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Q"
    });
    Object.defineProperty(MScoreOverrideLabelsDomain, "Qs", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "QS"
    });
    Object.defineProperty(MScoreOverrideLabelsDomain, "Sr", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "SR"
    });
    Object.defineProperty(MScoreOverrideLabelsDomain, "Qr", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "QR"
    });
    Object.defineProperty(MScoreOverrideLabelsDomain, "Qsr", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "QSR"
    });
    Object.defineProperty(MScoreOverrideLabelsDomain, "A", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "A"
    });
    Object.defineProperty(MScoreOverrideLabelsDomain, "As", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "AS"
    });
    Object.defineProperty(MScoreOverrideLabelsDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
